// Keep quick interactions free of spinner flashes while still acknowledging
// requests that take long enough to feel delayed.
export const LOADING_INDICATOR_GRACE_PERIOD_MS = 200;
